// extracted by mini-css-extract-plugin
module.exports = {"markdown":"style_markdown__2nUCz","secondaryText":"style_secondaryText__2PxB2"};